export default __webpack_public_path__ + "static/media/asta-18857.ba56cca4.png";